import { api_get, api_post } from "./utils"

const MessageAPI = {
    list: list,
    send: sendMessage,
};

async function list(collabKey : string, identityKey: string, cursor = "") {
	let url = `/message/list?collab=${collabKey}&identity=${identityKey}`;
	if(cursor) { url += `&cursor=${cursor}`; }
	return api_get(url).then(async (res) => {
		if(res.ok) {
			return await res.json();
		}
            else {
                throw await res.json();
            }
	});
}

async function sendMessage(collab: string, identity: string, content: string, ignored_qa = '') {
    return api_post('/message/send', {
        collab, identity, content, ignored_qa
    })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
            else {
                throw await res.json();
            }
        });

}

export default MessageAPI;
